{
	"emptyProductFeatureForm": {
		"description": "Sélectionnez un modèle d'informations produit personnalisé. Pour créer un nouveau modèle, accédez à la page",
		"link": "Modèles de fonctionnalité des produits.",
		"title": "Pas de modèle de fonctionnalité sélectionné"
	}
}
